import React from "react"
// import { Link } from 'gatsby'
import styled from "styled-components"
import colors from "../styles/colors"
import media from "../styles/media"
import text from "../styles/text"
import ContentWidth from "./ContentWidth"

const ThreeGrid = ({ content }) => {
  const columnData = content.columns.map(contentData => (
    <GridItemContainer key={contentData.icon?.alt_text}>
      <Icon
        alt={contentData?.icon?.alttext}
        src={contentData.icon?.sourceUrl}
        loading="eager"
      />
      <Headline>{contentData.headline}</Headline>
      <ItemBody dangerouslySetInnerHTML={{ __html: contentData.bodyCopy }} />
      {contentData?.link && <A href={contentData.link}>Check it out →</A>}
    </GridItemContainer>
  ))

  return (
    <ContentWidth>
      {content?.eyebrow && <Eyebrow> {content.eyebrow} </Eyebrow>}
      {content?.sectionHeader && <Header>{content.sectionHeader}</Header>}
      <ColumnsContainer>
        <GridContainer>{columnData}</GridContainer>
      </ColumnsContainer>
      <Button href={content.ctaLink} target="_blank" rel="noopener noreferrer">
        {content.ctaText}
      </Button>
    </ContentWidth>
  )
}

const Eyebrow = styled.p`
  ${text.eyebrow};
`
const Header = styled.h2`
  ${text.h2};
  text-align: center;
  padding: 0 0 5.556vw 0;
  width: 79.444vw;

  ${media.fullWidth} {
    padding: 0 0 80px 0;
    width: 1144px;
  }

  ${media.tablet} {
  }

  ${media.mobile} {
  }
`
const Button = styled.button`
  display: inline-block;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: 1.736vw;
  padding: 0.278vw 0.556vw;
  margin: 0.556vw 0vw;

  ${media.fullWidth} {
    border-radius: 25px;
    padding: 4px 8px;
    margin: 8px 0px;
  }

  ${media.tablet} {
    border-radius: 2.441vw;
    padding: 0.391vw 0.781vw;
    margin: 0.781vw 0vw;
  }

  ${media.mobile} {
  }
`

const ColumnsContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`
const GridContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: auto;
  flex-wrap: wrap;
  width: 95.625vw;
  gap: 4.167vw 2.778vw;

  ${media.fullWidth} {
    width: 1377px;
    gap: 60px 40px;
  }

  ${media.tablet} {
    align-items: flex-start;
    justify-content: flex-start;
    width: 79%;
    gap: 3.906vw 0.977vw;
  }

  ${media.mobile} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 85.625vw;
    gap: 4.673vw;
  }
`

const GridItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 24.583vw;
  height: auto;

  ${media.fullWidth} {
    width: 354px;
    height: auto;
  }

  ${media.tablet} {
    width: 38.477vw;
    height: auto;
  }

  ${media.mobile} {
    width: 84.112vw;
  }
`
const A = styled.a`
  color: ${colors.primaryOrange};
  font-family: "Archivo", sans-serif;
  font-size: 1.25vw;
  font-weight: 700;

  ${media.fullWidth} {
    font-size: 18px;
  }
  ${media.tablet} {
    font-size: 1.758vw;
  }
  ${media.mobile} {
    font-size: 4.206vw;
  }
  ${media.hover} {
    :hover {
      text-decoration: underline;
    }
  }
`

const Icon = styled.img`
  width: 5.208vw;
  height: 5.208vw;

  ${media.fullWidth} {
    width: 75px;
    height: 75px;
  }

  ${media.tablet} {
    width: 7.324vw;
    height: 6.738vw;
  }

  ${media.mobile} {
    width: 17.523vw;
    height: 17.523vw;
    margin-top: 8.336vw;
  }
`
const Headline = styled.h6`
  color: ${colors.grey800};
  font-weight: bold;
  margin-bottom: 0.556vw;
  margin-top: 1.111vw;
  font-size: 1.25vw;

  ${media.fullWidth} {
    margin-bottom: 8px;
    margin-top: 16px;
    font-size: 18px;
  }

  ${media.tablet} {
    font-size: 1.758vw;
    margin-bottom: 0.781vw;
    margin-top: 1.563vw;
  }

  ${media.mobile} {
    font-size: 4.206vw;
    margin-bottom: 1.869vw;
    margin-top: 3.738vw;
  }
`
const ItemBody = styled.div`
  p {
    font-family: Archivo, sans;
    color: ${colors.grey700};
    font-size: 1.389vw;
    line-height: 2.083vw;
    width: 23.611vw;

    ${media.fullWidth} {
      font-size: 20px;
      line-height: 30px;
      width: 340px;
    }

    ${media.tablet} {
      font-size: 2.344vw;
      line-height: 2.93vw;
      width: 100%;
      position: relative;
      left: 1vw;
    }

    ${media.mobile} {
      font-size: 4.673vw;
      line-height: 7.009vw;
      width: 100%;
    }
  }
`

export default ThreeGrid
